"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fakeStorage = void 0;
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
exports.fakeStorage = (function () {
    let store = {};
    return {
        getItem: (key) => {
            return store[key] || null;
        },
        setItem: (key, value) => {
            store[key] = value.toString();
        },
        removeItem: (key) => {
            delete store[key];
        },
        clear: () => {
            store = {};
        }
    };
})();
//# sourceMappingURL=mock-storage.js.map